import extend from './extend';
export var TranscriptEntityType;
(function (TranscriptEntityType) {
    TranscriptEntityType["BankingInformation"] = "banking_information";
    TranscriptEntityType["BloodType"] = "blood_type";
    TranscriptEntityType["CreditCardCVV"] = "credit_card_cvv";
    TranscriptEntityType["CreditCardExpiration"] = "credit_card_expiration";
    TranscriptEntityType["CreditCardNumber"] = "credit_card_number";
    TranscriptEntityType["Date"] = "date";
    TranscriptEntityType["DateOfBirth"] = "date_of_birth";
    TranscriptEntityType["DriversLicense"] = "drivers_license";
    TranscriptEntityType["Drug"] = "drug";
    TranscriptEntityType["Event"] = "event";
    TranscriptEntityType["EmailAddress"] = "email_address";
    TranscriptEntityType["Injury"] = "injury";
    TranscriptEntityType["Language"] = "language";
    TranscriptEntityType["Location"] = "location";
    TranscriptEntityType["MedicalCondition"] = "medical_condition";
    TranscriptEntityType["MedicalProcess"] = "medical_process";
    TranscriptEntityType["MoneyAmount"] = "money_amount";
    TranscriptEntityType["Nationality"] = "nationality";
    TranscriptEntityType["Occupation"] = "occupation";
    TranscriptEntityType["Organization"] = "organization";
    TranscriptEntityType["PersonAge"] = "person_age";
    TranscriptEntityType["PersonName"] = "person_name";
    TranscriptEntityType["PhoneNumber"] = "phone_number";
    TranscriptEntityType["PoliticalAffiliation"] = "political_affiliation";
    TranscriptEntityType["Religion"] = "religion";
    TranscriptEntityType["UsSocialSecurityNumber"] = "us_social_security_number";
    TranscriptEntityType["Unknown"] = "unknown";
})(TranscriptEntityType || (TranscriptEntityType = {}));
export var TranscriptSource;
(function (TranscriptSource) {
    TranscriptSource["AssemblyAI"] = "assemblyai";
    TranscriptSource["AWSTranscribe"] = "aws-transcribe";
    TranscriptSource["ParsedFile"] = "parsed-file";
})(TranscriptSource || (TranscriptSource = {}));
export var TranscriptPromptTemplate;
(function (TranscriptPromptTemplate) {
    TranscriptPromptTemplate[TranscriptPromptTemplate["UnmetNeedsSummary"] = 1] = "UnmetNeedsSummary";
})(TranscriptPromptTemplate || (TranscriptPromptTemplate = {}));
const templateMap = new Map([
    [TranscriptPromptTemplate.UnmetNeedsSummary, { name: 'Unmet Needs' }],
]);
export const TranscriptEntityType_utils = extend(new Map([
    [TranscriptEntityType.BankingInformation, { name: 'Banking Information' }],
    [TranscriptEntityType.BloodType, { name: 'Blood Type' }],
    [TranscriptEntityType.CreditCardCVV, { name: 'Credit Card CVV' }],
    [TranscriptEntityType.CreditCardExpiration, { name: 'Credit Card Expiration' }],
    [TranscriptEntityType.CreditCardNumber, { name: 'Credit Card Number' }],
    [TranscriptEntityType.Date, { name: 'Date' }],
    [TranscriptEntityType.DateOfBirth, { name: 'Date of Birth' }],
    [TranscriptEntityType.DriversLicense, { name: 'Driver\'s License' }],
    [TranscriptEntityType.Drug, { name: 'Drug' }],
    [TranscriptEntityType.Event, { name: 'Event' }],
    [TranscriptEntityType.EmailAddress, { name: 'Email Address' }],
    [TranscriptEntityType.Injury, { name: 'Injury' }],
    [TranscriptEntityType.Language, { name: 'Language' }],
    [TranscriptEntityType.Location, { name: 'Location' }],
    [TranscriptEntityType.MedicalCondition, { name: 'Medical Condition' }],
    [TranscriptEntityType.MedicalProcess, { name: 'Medical Process' }],
    [TranscriptEntityType.MoneyAmount, { name: 'Money Amount' }],
    [TranscriptEntityType.Nationality, { name: 'Nationality' }],
    [TranscriptEntityType.Occupation, { name: 'Occupation' }],
    [TranscriptEntityType.Organization, { name: 'Organization' }],
    [TranscriptEntityType.PersonAge, { name: 'Person Age' }],
    [TranscriptEntityType.PersonName, { name: 'Person Name' }],
    [TranscriptEntityType.PhoneNumber, { name: 'Phone Number' }],
    [TranscriptEntityType.PoliticalAffiliation, { name: 'Political Affiliation' }],
    [TranscriptEntityType.Religion, { name: 'Religion' }],
    [TranscriptEntityType.Unknown, { name: 'Unknown' }],
    [TranscriptEntityType.UsSocialSecurityNumber, { name: 'US Social Security Number' }],
]));
export var StructuredSummaryFeedback;
(function (StructuredSummaryFeedback) {
    StructuredSummaryFeedback[StructuredSummaryFeedback["TooBroad"] = 1] = "TooBroad";
    StructuredSummaryFeedback[StructuredSummaryFeedback["TooSpecific"] = 2] = "TooSpecific";
    StructuredSummaryFeedback[StructuredSummaryFeedback["TooWordy"] = 3] = "TooWordy";
    StructuredSummaryFeedback[StructuredSummaryFeedback["IrrelevantTopic"] = 4] = "IrrelevantTopic";
    StructuredSummaryFeedback[StructuredSummaryFeedback["FalseStatements"] = 5] = "FalseStatements";
    StructuredSummaryFeedback[StructuredSummaryFeedback["OverGeneralization"] = 6] = "OverGeneralization";
    StructuredSummaryFeedback[StructuredSummaryFeedback["ToneIssues"] = 7] = "ToneIssues";
    StructuredSummaryFeedback[StructuredSummaryFeedback["FormattingIssues"] = 8] = "FormattingIssues";
})(StructuredSummaryFeedback || (StructuredSummaryFeedback = {}));
const structuredFeedbackMap = new Map([
    [StructuredSummaryFeedback.TooBroad, { name: 'Too Broad' }],
    [StructuredSummaryFeedback.TooSpecific, { name: 'Too Specific' }],
    [StructuredSummaryFeedback.TooWordy, { name: 'Too Wordy' }],
    [StructuredSummaryFeedback.IrrelevantTopic, { name: 'Irrelevant Topic' }],
    [StructuredSummaryFeedback.FalseStatements, { name: 'False Statements' }],
    [StructuredSummaryFeedback.OverGeneralization, { name: 'Over Generalization' }],
    [StructuredSummaryFeedback.ToneIssues, { name: 'Tone Issues' }],
    [StructuredSummaryFeedback.FormattingIssues, { name: 'Formatting Issues' }],
]);
export var TranscriptType;
(function (TranscriptType) {
    TranscriptType["VoiceCall"] = "voice-call";
    TranscriptType["VideoCall"] = "video-call";
    TranscriptType["PostMedia"] = "post-media";
    TranscriptType["VoiceCallTrack"] = "voice-call-track";
    TranscriptType["RoomTrack"] = "room-track";
    TranscriptType["UserParticipantTrack"] = "user-participant-track";
    TranscriptType["Debug"] = "debug";
    TranscriptType["WorkspaceFile"] = "workspace-file";
})(TranscriptType || (TranscriptType = {}));
export var TranscriptPublishType;
(function (TranscriptPublishType) {
    TranscriptPublishType[TranscriptPublishType["RecordingAndTranscript"] = 1] = "RecordingAndTranscript";
    TranscriptPublishType[TranscriptPublishType["RecordingOnly"] = 2] = "RecordingOnly";
    TranscriptPublishType[TranscriptPublishType["TranscriptOnly"] = 3] = "TranscriptOnly";
    TranscriptPublishType[TranscriptPublishType["None"] = 4] = "None";
    TranscriptPublishType[TranscriptPublishType["VideoAndTranscript"] = 5] = "VideoAndTranscript";
})(TranscriptPublishType || (TranscriptPublishType = {}));
export const TranscriptPublishType_utils = extend(new Map([
    [TranscriptPublishType.RecordingAndTranscript, { name: 'Recording + Transcript' }],
    [TranscriptPublishType.RecordingOnly, { name: 'Recording Only' }],
    [TranscriptPublishType.TranscriptOnly, { name: 'Transcript Only' }],
    [TranscriptPublishType.None, { name: 'None' }],
    [TranscriptPublishType.VideoAndTranscript, { name: 'Video + Transcript' }],
]));
export var TranscriptionRevisionStatus;
(function (TranscriptionRevisionStatus) {
    TranscriptionRevisionStatus[TranscriptionRevisionStatus["InQueue"] = 1] = "InQueue";
    TranscriptionRevisionStatus[TranscriptionRevisionStatus["InProgress"] = 2] = "InProgress";
    TranscriptionRevisionStatus[TranscriptionRevisionStatus["Completed"] = 3] = "Completed";
})(TranscriptionRevisionStatus || (TranscriptionRevisionStatus = {}));
export const TranscriptRevisionStatus_utils = extend(new Map([
    [TranscriptionRevisionStatus.InQueue, { name: 'In-Queue' }],
    [TranscriptionRevisionStatus.InProgress, { name: 'In-Progress' }],
    [TranscriptionRevisionStatus.Completed, { name: 'Completed' }],
]));
export var FileTranscriptStatus;
(function (FileTranscriptStatus) {
    FileTranscriptStatus["InProgress"] = "in-progress";
    FileTranscriptStatus["Errored"] = "errored";
    FileTranscriptStatus["Complete"] = "complete";
})(FileTranscriptStatus || (FileTranscriptStatus = {}));
export default {
    StructuredSummaryFeedback: extend(structuredFeedbackMap),
    TranscriptEntityType: TranscriptEntityType_utils,
    TranscriptPromptTemplate: extend(templateMap),
    TranscriptPublishType: TranscriptPublishType_utils,
    TranscriptionRevisionStatus: TranscriptRevisionStatus_utils,
};
